<template>
	<div class="panel panel-default" :class="{fullcav:!!this.fullcav,unbg:!!this.unbg}">
		<div class="panel-heading" v-if="hashead">
			{{header}}
			<slot name="title"></slot>
			<ul v-if="!!tooltip" class="list-inline pull-right">
				<li @click="close()">
					<icon icon="zheqi"></icon>
				</li>
				<li>
					<icon icon="gongdan"></icon>
				</li>
				<li>
					<icon icon="tuichu"></icon>
				</li>
			</ul>
		</div>
		<transition name="fade">
			<div class="panel-body" v-if="!!show">
				<slot name="body"></slot>
			</div>
		</transition>
		<div class="panel-footer" v-if="!!footer">
			<slot name="footer"></slot>
		</div>
	</div>
</template>

<script>
	import icon from "../comp/icon"
	export default {
		components: {
			icon,
		},
		props: {
			size: String,
			hashead: {
				type: Boolean,
				default: true
			},
			header: {
				type: String,
			},
			tooltip: {
				type: Boolean,
				default: false
			},
			footer: Boolean,
			fullcav: {
				type: Boolean,
				default: false
			},
			unbg: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				show: true
			}
		},
		methods: {
			close() {
				this.show = !this.show;
			}
		},
		computed: {}

	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import (reference) "../../assets/lib/css.less";
	.panel {
		.mgb(2*@mpb);
		&.panel-default {
			.panel-heading {
				background-color: @cwh;
			}
		}
		&-heading {
			position: relative;
			.pdt;
			.pdb;
			.list-inline,
			.label,
			.badges {
				&.pull-right {
					position: absolute;
					top: 50%;
					right: @mpb;
					transform: translateY(-50%);
					.mgb(0);
					.iconfont {
						color: @cc2;
						cursor: pointer;
						&:hover {
							color: @ces;
						}
					}
				}
			}
		}
		&-title {
			font-size: 14px;
		}
		&-body {
			.media-list {
				.mgb(0);
			}
		}
		&.fullcav {
			.panel-body {
				.pd(0);
			}
		}
		&.unbg {
			.unbg;
		}
		&.titinfo {
			.panel-body {
				.tits {
					font-weight: normal;
					.mgb(0);
					.mgt(0);
				}
				.info {
					.mgt;
					.mgb(0);
					line-height: 20px;
					.iconfont {
						font-size: 12px;
					}
				}
			}
		}
	}
	/*transition*/
	
	.fade-enter-active,
	.fade-leave-active {
		.trs;
	}
	
	.fade-enter,
	.fade-leave-active {
		opacity: 0;
	}
</style>


// WEBPACK FOOTER //
// panel.vue?d0c49486